import { Layout } from "antd";
import { Outlet } from "react-router-dom";

import Breadcrumbs from "../Breadcrumbs";
import Header from "../Header/Header";

const { Header: AntHeader, Content, Footer } = Layout;

const BasicLayout = () => {
  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <AntHeader
          style={{
            position: "fixed",
            zIndex: 1,
            top: 0,
            width: "100%",
            paddingLeft: "35px",
            paddingRight: "35px",
            borderRadius: "0 0 2px 2px",
          }}
        >
          <Header />
        </AntHeader>
        <Content style={{ marginTop: 80, padding: "0 50px" }}>
          <div
            style={{
              color: "#00000073",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Breadcrumbs />
          </div>
          <Outlet />
        </Content>
        <Footer style={{ textAlign: "center" }}>Created by prenode GmbH</Footer>
      </Layout>
    </>
  );
};

export default BasicLayout;
